// Device Actions
import { createAction, props } from '@ngrx/store';
import { DeviceIdentityModel, DeviceTwinModel, DirectMethodResponse, C2DSendResponse, TelemetryMessage } from '../../services/device.service';

// Set current device
export const setCurrentDevice = createAction(
  '[Device] Set Current Device',
  props<{ deviceId: string }>()
);
export const clearCurrentDevice = createAction('[Device] Clear Current Device');

// Load Identity
export const loadIdentity = createAction(
  '[Device] Load Identity',
  props<{ deviceId: string }>()
);
export const loadIdentitySuccess = createAction(
  '[Device] Load Identity Success',
  props<{ identity: DeviceIdentityModel }>()
);
export const loadIdentityFailure = createAction(
  '[Device] Load Identity Failure',
  props<{ error: string }>()
);

// Load Twin
export const loadTwin = createAction(
  '[Device] Load Twin',
  props<{ deviceId: string }>()
);
export const loadTwinSuccess = createAction(
  '[Device] Load Twin Success',
  props<{ twin: DeviceTwinModel }>()
);
export const loadTwinFailure = createAction(
  '[Device] Load Twin Failure',
  props<{ error: string }>()
);

// Update Connection State
export const updateConnectionState = createAction(
  '[Device] Update Connection State',
  props<{ connectionState: 'Connected' | 'Disconnected' }>()
);

// Direct Method
export const invokeDirectMethod = createAction(
  '[Device] Invoke Direct Method',
  props<{ deviceId: string; methodName: string; payload?: Record<string, unknown>; timeout?: number }>()
);
export const invokeDirectMethodSuccess = createAction(
  '[Device] Invoke Direct Method Success',
  props<{ result: DirectMethodResponse }>()
);
export const invokeDirectMethodFailure = createAction(
  '[Device] Invoke Direct Method Failure',
  props<{ error: string }>()
);
export const clearDirectMethodResult = createAction('[Device] Clear Direct Method Result');

// Cloud to Device Message
export const sendC2DMessage = createAction(
  '[Device] Send C2D Message',
  props<{ deviceId: string; message: string }>()
);
export const sendC2DMessageSuccess = createAction(
  '[Device] Send C2D Message Success',
  props<{ result: C2DSendResponse }>()
);
export const sendC2DMessageFailure = createAction(
  '[Device] Send C2D Message Failure',
  props<{ error: string }>()
);
export const clearC2DResult = createAction('[Device] Clear C2D Result');

// Telemetry
export const loadTelemetry = createAction(
  '[Device] Load Telemetry',
  props<{ deviceId: string; limit?: number }>()
);
export const loadTelemetrySuccess = createAction(
  '[Device] Load Telemetry Success',
  props<{ messages: TelemetryMessage[] }>()
);
export const loadTelemetryFailure = createAction(
  '[Device] Load Telemetry Failure',
  props<{ error: string }>()
);
export const addTelemetryMessage = createAction(
  '[Device] Add Telemetry Message',
  props<{ message: TelemetryMessage }>()
);
export const clearTelemetry = createAction('[Device] Clear Telemetry');
